var map = {
	".": 4744,
	"./": 4744,
	"./assets/712.jpg": 383,
	"./assets/Compassbox.jpg": 4238,
	"./assets/Jameson.jpg": 9500,
	"./assets/abr.jpg": 7449,
	"./assets/amazon.jpg": 9237,
	"./assets/ardnamu.webp": 8269,
	"./assets/ardnamurchan.webp": 2121,
	"./assets/bread.jpg": 8638,
	"./assets/caol.JPG": 1037,
	"./assets/dalmore.jpg": 2163,
	"./assets/female.jpg": 7378,
	"./assets/glasgow.webp": 4588,
	"./assets/glasgow2.webp": 3593,
	"./assets/glen-moray.webp": 4548,
	"./assets/glen.jpg": 1969,
	"./assets/glen.webp": 2001,
	"./assets/glendr.jpg": 3320,
	"./assets/glenglass.jpg": 8359,
	"./assets/goldenBtn.png": 4033,
	"./assets/hamish.jpg": 4147,
	"./assets/hero.jpg": 5515,
	"./assets/herogrid.jpg": 2478,
	"./assets/jap.jpg": 7533,
	"./assets/logo.jpg": 2776,
	"./assets/mm.jpg": 801,
	"./assets/nikka.webp": 5726,
	"./assets/port.webp": 2344,
	"./assets/redbreast.webp": 6201,
	"./assets/scall.jpg": 5185,
	"./assets/storm.jpg": 3095,
	"./assets/stylishwhisky.jpg": 2205,
	"./assets/tali.jpg": 7780,
	"./assets/taliska.jpg": 9013,
	"./assets/tob copy.jpg": 1645,
	"./assets/tob.jpg": 334,
	"./assets/tobermory.webp": 1021,
	"./assets/whisky+Tasting+set.jpg": 1414,
	"./index": 4744,
	"./index.js": 4744,
	"./style.css": 2270
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8888;